import { useState, useEffect } from "react";
import { Star } from "lucide-react";

const StarRating = ({ totalStars = 5 , value = 0, onChange = () => {},readOnly = false }) => {
   const [rating, setRating] = useState(value);
  useEffect(() => {
    setRating(value);
  }, [value]);

  // const handleClick = (event, index) => {
  //   // Calculate position of click relative to star element width
  //   const { left, width } = event.currentTarget.getBoundingClientRect();
  //   const clickX = event.clientX - left;

  //   if (clickX < width / 2) {
  //     // Clicked on left half => set half star rating
  //     setRating(index + 0.5);
  //   } else {
  //     // Clicked on right half => set full star rating
  //     setRating(index + 1);
  //   }
  // };

  const handleClick = (index) => {
     if (readOnly) return; 
    const newRating = index + 1;
    setRating(newRating);
    onChange(newRating);
    
  };


  return (
    <div className="rating-container">
      {[...Array(totalStars)].map((_, index) => {
        const fullStars = Math.floor(rating);
        const hasHalfStar = rating % 1 !== 0;
        const isFull = index < fullStars;
        const isHalf = hasHalfStar && index === fullStars;

        let fillColor = "none";
        let strokeColor = "#F4C116";

        if (isFull) {
          fillColor = "#F4C116";
        } else if (isHalf) {
          // We'll render half star with SVG trick below
          fillColor = "url(#halfGradient)";
        }

        return (
          <svg
            key={index}
             onClick={() => handleClick(index)}
            // onClick={(e) => handleClick(e, index)}
            className="h-6 w-6 cursor-pointer transition-colors text-yellow-400"
            stroke={strokeColor}
            strokeWidth={1}
            viewBox="0 0 24 24"
            fill={fillColor}
            xmlns="http://www.w3.org/2000/svg"
          >
            <defs>
              <linearGradient id="halfGradient">
                <stop offset="50%" stopColor="#F4C116" />
                <stop offset="50%" stopColor="transparent" />
              </linearGradient>
            </defs>
            <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
          </svg>
        );
      })}
    </div>
  );
};

export default StarRating;
